import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windowCamera",
  "use": "icon-windowCamera-usage",
  "viewBox": "0 0 14 10.639",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 10.639\" id=\"icon-windowCamera\"><path d=\"M13.16 10.639H.84a.84.84 0 0 1-.84-.84v-7.28a.84.84 0 0 1 .84-.84h2.52c.84 0 1.12-1.68 1.68-1.68h3.637c.833 0 1.151 1.68 1.96 1.68h2.52a.84.84 0 0 1 .84.84v7.28a.84.84 0 0 1-.837.84zM7 2.519a3.36 3.36 0 1 0 3.36 3.36A3.36 3.36 0 0 0 7 2.52zm4.06 0a.42.42 0 1 0 .42.42.42.42 0 0 0-.42-.419zM7 8.399a2.52 2.52 0 1 1 2.52-2.521A2.52 2.52 0 0 1 7 8.4zM1.4.839a.28.28 0 0 1 .28-.28h.84a.28.28 0 0 1 .28.28v.28H1.4v-.28zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol